import React, { useState } from "react";
import PropTypes from "prop-types";
import Chip from "./chip";
import ColumnsFilter from "./columns-filter";
import AutoComplete from "./autocomplete";
import DeleteAllFilterButton from "./delete-all-filter";
import Filters from "./filters";
import TooltipButton from "../tooltip-button";
import { columnShape } from "./utils";
import { fireEvent } from "../../../utils/google-analytics-handler";

const Toolbar = ({
  placeHolder,
  queryChange,
  extraToolbarOptions,
  activeFilters,
  onFilterChange,
  columnFilters,
  onColumnFilterChange,
  onGenerateCSVClick,
  suggestions,
  data,
  columns,
  removeDownloadAction,
  enableGoogleAnalytics
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [chipsFilters, setChipsFilters] = useState(activeFilters);

  const removeFilter = index => {
    const newFilters = chipsFilters.filter((x, i) => i !== index);
    setChipsFilters([...newFilters]);
    onFilterChange([...newFilters]);
  };
  const chipTextRender = (key, value) => {
    const column = columns.find(x => x.name === key);
    return column && column.options && column.options.filterRenderer
      ? column.options.filterRenderer(value)
      : value;
  };
  const selectedFilterChips = chipsFilters.map((x, index) => (
    <Chip id={index} name={chipTextRender(x.key, x.value)} onClick={id => removeFilter(id)} />
  ));
  const emptyFilters = () => {
    setChipsFilters([]);
    onFilterChange([]);
  };
  return (
    <div className="table-toolbar">
      <div className="row">
        <div className="col-6">
          <div className="row left-tool-table">
            <AutoComplete
              placeHolder={placeHolder}
              suggestions={suggestions}
              value={searchQuery}
              onValueChanged={value => {
                if (enableGoogleAnalytics) {
                  fireEvent("ConciliationProposal", "Search", `Content search: ${value}`);
                }
                setSearchQuery(value);
                queryChange(value);
              }}
            />
            <div className="col-2">
              <div className="row">
                <Filters
                  clearFilters={() => emptyFilters()}
                  onChipFilterChange={newValues => setChipsFilters(newValues)}
                  onFilterChange={newValues => onFilterChange(newValues)}
                  activeFilters={chipsFilters}
                  data={data}
                  columns={columns}
                  enableGoogleAnalytics={enableGoogleAnalytics}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-6 right-tool-table">
          <div className="d-flex align-items-center float-right">
            {!removeDownloadAction && (
              <TooltipButton
                tag="button"
                buttonClassName="btn-tool-table"
                iconClassName="icono-download"
                tooltipText="Descargar CVS"
                onClick={() => onGenerateCSVClick()}
              />
            )}
            {Boolean(columnFilters.length) && (
              <ColumnsFilter
                columnFilters={columnFilters}
                onColumnFilterChange={onColumnFilterChange}
              />
            )}
            {extraToolbarOptions && (
              <div>
                <span className="toolbar-divider">|</span>
                {extraToolbarOptions}
              </div>
            )}
          </div>
        </div>
      </div>
      {chipsFilters.length > 0 && (
        <div className="row">
          <div className="col-12 d-flex mt-1 mb-2 align-items-center">
            <span className="filter-by">Filtrado por: </span>
            {selectedFilterChips}
            <DeleteAllFilterButton onClick={() => emptyFilters()} />
          </div>
        </div>
      )}
    </div>
  );
};

Toolbar.propTypes = {
  onFilterChange: PropTypes.func,
  onColumnFilterChange: PropTypes.func,
  columnFilters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired
    })
  ),
  activeFilters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    })
  ),
  queryChange: PropTypes.func,
  extraToolbarOptions: PropTypes.node,
  onGenerateCSVClick: PropTypes.func,
  suggestions: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(PropTypes.shape({})),
  columns: PropTypes.arrayOf(PropTypes.shape(columnShape)).isRequired,
  removeDownloadAction: PropTypes.bool,
  enableGoogleAnalytics: PropTypes.bool,
  placeHolder: PropTypes.string
};

Toolbar.defaultProps = {
  removeDownloadAction: false,
  onFilterChange: () => {},
  columnFilters: [],
  onColumnFilterChange: () => {},
  queryChange: () => {},
  extraToolbarOptions: undefined,
  onGenerateCSVClick: () => {},
  suggestions: [],
  activeFilters: [],
  data: [],
  enableGoogleAnalytics: false,
  placeHolder: ""
};

export default Toolbar;
